import * as React from 'react';
import Card from '@mui/material/Card'
import Avatar from '@mui/material/Avatar'
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import DeleteIcon from '@mui/icons-material/Delete';
import Fab from '@mui/material/Fab';
import ConfirmDialog from '../Modals/ConfirmDialog';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import IconButton from '@mui/material/IconButton';

export default function BrankLookupItem(props) {

    const [confirmDialog, setConfirmDialog] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [brandLookupItem, setBrandLookupItem] = React.useState(props.brand);

    function confirmDeleteBrandEntry() {
        setConfirmDialog({
            show: true,
            close: closeDeleteBrandEntryDialog,
            title: 'Remove Entry',
            cancelText: 'Cancel',
            acceptText: 'Proceed',
            content: <div>Do you want to remove this Brand Lookup entry?</div>,
            data: ''
        });
    }

    function closeDeleteBrandEntryDialog(didAccept) {
        if (didAccept) {
            // post
            setIsLoading(true);
            let postData = {
                BrandLookupId: brandLookupItem.BrandLookupId
            }
            TokenService.post(postData, 'BrandLookup_Delete')
                .then((response) => {

                    if (response.Result === "SUCCESS") {
                        let data = JSON.parse(response.JsonData);
                        /* setBrandLookupData(JSON.parse(data.BrandLookup));*/
                    }
                    setIsLoading(false);
                    if (props.onChange !== undefined) {
                        props.onChange(brandLookupItem, 'Delete');
                    }
                })
                .catch((response) => {
                    setIsLoading(false);
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                    setIsLoading(false);
                });
          
        }
        setConfirmDialog(null);
    }

    function getFeedbackCount(isUpVote) {
        let count = 0;
        let currentUserGaveFeedback = false;
        if (brandLookupItem.Feedback == undefined) {
            return {
                count: 0,
                currentUserGaveFeedback: false
            }
        }

        for (let i = 0; i < brandLookupItem.Feedback.length; i++) {
            if (isUpVote) {
                if (brandLookupItem.Feedback[i].IsVoteUp) {
                    count++;
                    if (brandLookupItem.Feedback[i].IsCurrentUser) {
                        currentUserGaveFeedback = true;
                    }
                }
               
            }
            else {
                if (!brandLookupItem.Feedback[i].IsVoteUp) {
                    count++;
                    if (brandLookupItem.Feedback[i].IsCurrentUser) {
                        currentUserGaveFeedback = true;
                    }
                }
              
            }
            
        }
        return {
            count: count,
            currentUserGaveFeedback: currentUserGaveFeedback
        }

    }

    function updateFeedbackClicked(isUpVote) {
        
        setIsLoading(true);
        let postData = {
            BrandLookupId: brandLookupItem.BrandLookupId
            ,isUpVote: isUpVote
        }
        TokenService.post(postData, 'BrandLookupFeedback_Vote')
            .then((response) => {

                if (response.Result === "SUCCESS") {
                    let data = JSON.parse(response.JsonData);
                    let brand = JSON.parse(data.Brand);
                    setBrandLookupItem(brand);
                    if (props.onChange !== undefined) {
                        props.onChange(brand, 'Update');
                    }
                }
                setIsLoading(false);
              
            })
            .catch((response) => {
                setIsLoading(false);
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
                isLoading(false);
            });

           
    }

    function capFirstLetter(word) {
        if (word.length > 2) {
            return word.charAt(0).toUpperCase()
                + word.slice(1);
        }
        else {
            return word;
        }
    }

    let upVoteCounts = getFeedbackCount(true);
    let downVoteCounts = getFeedbackCount(false);

    return <Card style={{ padding: '3px', marginBottom: '3px' } }>
        <div style={{display:'flex', justifyContent:'space-between'} }>
            <div>
                <div style={{fontWeight:'bold', fontSize:'12pt', textAlign:'left', padding:'2px', display:'flex'} }>
                    <LocalGroceryStoreIcon sx={{ color: brandLookupItem.IsAccepted ? 'var(--sipzee-green)' : 'var(--sipzee-red)' }} />
                    <div style={{alignSelf:'center'} }>
                        {brandLookupItem.StoreName}
                    </div>
                </div>
                <div style={{ textAlign: 'left', padding: '2px', fontSize:'14pt' } }>
                    {capFirstLetter(brandLookupItem.CompanyName)}
                </div>
                {brandLookupItem.BrandName == '' ? null :
                    <div style={{ textAlign: 'left', marginLeft: '25px', padding: '2px' }}>
                        {capFirstLetter(brandLookupItem.BrandName)}
                    </div>
                }
                {brandLookupItem.StoreAddress == null ? null :
                    <div>{brandLookupItem.StoreAddress }</div>
                }
                {brandLookupItem.StoreCity == null ? null :
                    <div>{brandLookupItem.StoreCity} {brandLookupItem.StoreState} {brandLookupItem.StoreZip}</div>
                }
                {brandLookupItem.Recycler == null ? null :
                    <div style={{display:'flex'} }>
                        <Avatar
                            alt="Photo"
                            src={brandLookupItem.Recycler.ReturnerPhoto}
                            sx={{ width: 30, height: 30, alignSelf: 'center' }}
                        />
                        <div style={{fontSize:'9pt', alignSelf:'center', marginLeft:'5px'} }>
                            added by {brandLookupItem.IsCurrentUser ? 'You'  :  brandLookupItem.Recycler.FirstName }
                        </div>
                        {brandLookupItem.IsCurrentUser ?
                            <Fab onClick={(e) => confirmDeleteBrandEntry()} style={{ marginLeft: '25px' }} size={'small'}><DeleteIcon /></Fab>
                            : null
                        }
                    </div>
                }
            </div>
            <div>
                <span style={{ marginRight: '25px' }}><IconButton onClick={() => updateFeedbackClicked(true)}>{upVoteCounts.currentUserGaveFeedback ? <ThumbUpIcon sx={{ color: 'var(--sipzee-green)' }} /> : <ThumbUpOffAltIcon />}</IconButton> {upVoteCounts.count}</span>
                <span style={{ marginRight: '25px' }}><IconButton onClick={() => updateFeedbackClicked(false)}>{downVoteCounts.currentUserGaveFeedback ? <ThumbDownIcon sx={{ color: 'var(--sipzee-red)' }} /> : <ThumbDownOffAltIcon />}</IconButton> {downVoteCounts.count}</span>
            </div>
        </div>
        {confirmDialog !== null ?
            <ConfirmDialog Close={confirmDialog.close} Title={confirmDialog.title} Content={confirmDialog.content} CancelText={confirmDialog.cancelText} AcceptText={confirmDialog.acceptText} Data={confirmDialog.data} />
            : null
        }
    </Card>
}